document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM cargado, configurando botones alternativos');
    
    // Función para buscar y simular clic en el elemento del chat
    function abrirChatDirectamente() {
        // Buscar el botón del logo que controla el chat original
        const logoButton = document.getElementById('smartchat-logo-button');
        
        if (logoButton) {
            console.log('Botón de logo encontrado, simulando clic');
            // Simular un clic nativo en el botón
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            
            // Disparar el evento
            logoButton.dispatchEvent(clickEvent);
        } else {
            console.error('No se encontró el botón de logo del chat');
            // Plan B: intentar manipular directamente el iframe
            const iframe = document.getElementById('smartchat-iframe');
            if (iframe) {
                console.log('Iframe encontrado, manipulando directamente');
                if (iframe.style.display === 'none' || !iframe.style.display) {
                    iframe.style.display = 'block';
                    setTimeout(() => {
                        iframe.style.opacity = '1';
                    }, 50);
                } else {
                    iframe.style.opacity = '0';
                    setTimeout(() => {
                        iframe.style.display = 'none';
                    }, 500);
                }
            } else {
                console.error('No se encontró ni el botón ni el iframe');
            }
        }
    }
    
    // Reemplazar los eventos de los botones originales
    const botonesChat = [
        document.getElementById('open-chat-button'),
        document.getElementById('open-chat-button-contact'),
        document.getElementById('open-chat-button-expert')
    ];
    
    // Añadir nuestro manejador de eventos a todos los botones existentes
    botonesChat.forEach(boton => {
        if (boton) {
            console.log('Configurando botón:', boton.id);
            
            // Eliminar cualquier evento previo (opcional, pero recomendado)
            const nuevoBoton = boton.cloneNode(true);
            boton.parentNode.replaceChild(nuevoBoton, boton);
            
            // Añadir nuestro evento personalizado
            nuevoBoton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation(); // Detener propagación para evitar conflictos
                console.log('Clic en botón personalizado:', this.id);
                abrirChatDirectamente();
                return false; // Prevenir comportamiento por defecto
            });
        }
    });
    
    // CSS para asegurar transiciones suaves
    const estilo = document.createElement('style');
    estilo.textContent = `
        #smartchat-iframe {
            transition: opacity 0.4s ease-in-out !important;
        }
    `;
    document.head.appendChild(estilo);
});